module.exports = __webpack_public_path__ + "media/images/start_header-199af196f58713c1deecf20aab73e2aa.webp";